import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, StarIcon } from 'lucide-react';
import { CHECKOUT_ESENCIAL, heroStats, heroTestimonials, trustItems } from '../data/content';
import { trackPixelEvent } from '../utils/metaPixel';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/1WY9hQJwc9LZ2RSLeyvuvZ/heylloyd-generated-1787099643954.png';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="w-full bg-ink pb-14 pt-5 md:pb-20 md:pt-14" data-id="element-76" data-mp="127eeddqu7pdg">
      <div className="mx-auto max-w-content px-5 md:px-8" data-id="element-77" data-mp="xbpcv4v9byei">
        <div className="grid gap-5 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:grid-rows-[auto_auto] lg:gap-x-16 lg:gap-y-8" data-id="element-78" data-mp="sb1chsl5257m">
          {/* Título y prueba social */}
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: EASE
        }} className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-79" data-mp="nekn6v27dksy">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-white md:text-sm" data-id="element-80" data-mp="3j897ze322dq2">
              Nuevo Nivel™ <span aria-hidden="true" data-id="element-81" data-mp="3o6kd5bieo01y">🇦🇷</span>{' '}
              <span className="text-white/40" data-id="element-82" data-mp="39acwgl67hgrf">Para Argentina</span>
            </p>

            <h1 className="mt-3 text-[1.9rem] font-extrabold leading-[1.08] tracking-tightest text-white sm:text-4xl lg:mt-5 lg:text-[3.5rem] lg:leading-[1.03]" data-id="element-83" data-mp="39cfotbutzlzb">
              El Mega Pack Kinesiología Remasterizada.
            </h1>

            <p className="mt-3 max-w-xl text-[13px] leading-snug text-white/65 md:mt-5 md:text-lg md:leading-relaxed" data-id="element-84" data-mp="3599jc6fjlytw">
              Protocolos, ejercicios, comunicación y retorno al deporte — todo resuelto, todo para
              el kinesiólogo argentino moderno.
            </p>

            <div className="mt-3 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs font-semibold text-white/80 md:mt-6 md:gap-x-3 md:text-sm" data-id="element-85" data-mp="2hj5ig6tqod6l">
              <span className="flex items-center gap-0.5" aria-hidden="true" data-id="element-86" data-mp="2ljgzzaqt1xdu">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-accent text-accent md:h-4 md:w-4" data-id="element-87" data-mp="s44j7qwfvrjh" />)}
              </span>
              <span data-id="element-88" data-mp="iboyiltrcouw">4.9/5</span>
              <span className="text-white/25" data-id="element-89" data-mp="id03uq2uq4o4">·</span>
              <span data-id="element-90" data-mp="ddf3cb819o9a">+800 kinesiólogos ya lo usan</span>
            </div>
          </motion.div>

          {/* Mockup del pack: arriba del CTA en mobile, a la derecha en desktop */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          delay: 0.06,
          ease: EASE
        }} className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-91" data-mp="1ayjilhmnxm7u">
            <img src={MOCKUP_URL} alt="Mega Pack de Kinesiología Remasterizada: 3 tomos y 6 bonos en formato PDF" className="mx-auto w-[58%] max-w-[220px] rounded-xl sm:w-[42%] lg:w-full lg:max-w-none lg:rounded-2xl" loading="eager" data-id="element-92" data-mp="x0uywd4c0l4d" />
            <p className="mt-2 text-center text-[10px] font-bold uppercase tracking-[0.14em] text-white/45 md:mt-4 md:text-xs" data-id="element-93" data-mp="1x783jjm4pjs0">
              3 Tomos + 6 Bonos · 150 páginas · 100% PDF
            </p>
          </motion.div>

          {/* CTA principal */}
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.1,
          ease: EASE
        }} className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-94" data-mp="2b0zcoqvy71n7">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-95" data-mp="2l0qc96zd86u5">
              <a href={CHECKOUT_ESENCIAL} onClick={() => trackPixelEvent('InitiateCheckout', {
              content_name: 'Mega Pack Esencial',
              value: 19990,
              currency: 'ARS'
            })} className="group inline-flex items-center justify-center gap-2 rounded-full bg-accent px-6 py-3.5 text-[15px] font-bold text-white transition-colors duration-150 ease-out hover:bg-accent-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-ink md:px-8 md:py-4 md:text-base" data-id="element-96" data-mp="2p1a4px8zum9y">
                <span aria-hidden="true" data-id="element-97" data-mp="9b0afqdxrrxy">🏆</span>
                Quiero mi Mega Pack ahora
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-98" data-mp="3hr231uwkg4p5" />
              </a>
              <a href="#contenido" className="hidden items-center justify-center rounded-full px-6 py-4 text-base font-semibold text-white/70 ring-1 ring-white/20 transition-colors duration-150 ease-out hover:text-white hover:ring-white/40 sm:inline-flex" data-id="element-99" data-mp="3rhenzo8alzvt">
                Ver qué incluye
              </a>
            </div>

            <ul className="mt-4 flex flex-wrap gap-x-3 gap-y-1.5 md:mt-7 md:gap-x-5 md:gap-y-2" data-id="element-100" data-mp="19hm6ruwim0gu">
              {trustItems.map(item => <li key={item} className="flex items-center gap-1 text-[11px] font-medium text-white/55 md:gap-1.5 md:text-[13px]" data-id="element-101" data-mp="1ebgpav0dw9ec">
                  <CheckIcon className="h-3 w-3 text-accent md:h-3.5 md:w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-102" data-mp="14ju3k4qf6rxc" />
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="mt-12 grid gap-5 border-t border-white/10 pt-8 md:mt-16 md:grid-cols-3 md:gap-4 md:pt-10" data-id="element-103" data-mp="1jajjtliqmx82">
          {heroTestimonials.map(t => <figure key={t.name} className="flex h-full flex-col" data-id="element-104" data-mp="7s8o4r6uxcng">
              <blockquote className="text-[15px] leading-relaxed text-white/85" data-id="element-105" data-mp="bun85em9iigb">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-3 text-xs font-semibold uppercase tracking-[0.12em] text-white/45 md:pt-4" data-id="element-106" data-mp="2egivmh7i8si9">
                {t.name} — {t.city}
              </figcaption>
            </figure>)}
        </div>

        <dl className="mt-10 grid grid-cols-2 gap-y-6 rounded-2xl bg-white/[0.04] px-6 py-7 md:mt-12 md:grid-cols-4" data-id="element-107" data-mp="24po693yypcsl">
          {heroStats.map(stat => <div key={stat.label} className="text-center" data-id="element-108" data-mp="1vs429n9pt2ea">
              <dt className="sr-only" data-id="element-109" data-mp="1qrzjfqlc3vkw">{stat.label}</dt>
              <dd data-id="element-110" data-mp="1qr6ix7cyy2b7">
                <span className="block text-3xl font-extrabold tracking-tight text-white" data-id="element-111" data-mp="1qqojk1v0f7z2">
                  {stat.value}
                </span>
                <span className="mt-1 block text-xs font-semibold uppercase tracking-[0.14em] text-white/45" data-id="element-112" data-mp="1gubnixbzsi15">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </header>;
}